const configuredBaseUrl = import.meta.env.VITE_STORIES_BASE_URL as string | undefined;

export function getStoriesBaseUrl(): string {
  return (configuredBaseUrl || 'https://stories.eplotera.com').replace(/\/$/, '');
}

export function getNovelShareUrl(publicationId: string): string {
  return `${getStoriesBaseUrl()}/read/${publicationId}`;
}

export function getChapterShareUrl(publicationId: string, chapterPublicId: string): string {
  return `${getNovelShareUrl(publicationId)}/${chapterPublicId}`;
}
